import React from 'react';
import { RouteConfig } from 'react-router-config';

import routesConfig from './pages';

const Home = React.lazy(() => import('@/page/home'));

const Layout = React.lazy(() => import('@/page/layout/index'));

const OaLogin = React.lazy(() => import('@/page/oa-login'));

const Login = React.lazy(() => import('@/page/login'));

const WithoutAuth = React.lazy(() => import('@/page/withoutAuth'));

const Registered = React.lazy(() => import('@/page/registered'));

const LoadData = React.lazy(() => import('@/page/app/welcome/loadData'));

const Callback = React.lazy(() => import('@/page/callback'));

const OAuthRedirect = React.lazy(() => import('@/page/oauth-redirect'));

const ROUTES: RouteConfig[] = [
  {
    path: '/login',
    exact: true,
    component: Login,
  },
  {
    path: '/oaLogin',
    exact: true,
    component: OaLogin,
  },
  {
    path: '/oAuth/redirect',
    exact: true,
    component: OAuthRedirect,
  },
  {
    path: '/withoutAuth',
    exact: true,
    component: WithoutAuth,
  },
  {
    path: '/withoutAuth/:lv3product',
    exact: true,
    component: WithoutAuth,
  },
  {
    path: '/home',
    exact: true,
    component: Home,
  },
  {
    path: '/registered',
    exact: true,
    component: Registered,
  },
  {
    path: '/loadData',
    exact: true,
    component: LoadData,
  },
  {
    path: '/callback',
    exact: true,
    component: Callback,
  },
  {
    path: ['/', '/admin'],
    component: Layout,
    routes: routesConfig,
  },
];

export default ROUTES;
